import { type FC } from 'react';

import AdminPanelSettingsOutlined from '@mui/icons-material/AdminPanelSettingsOutlined';
import CorporateFareOutlined from '@mui/icons-material/CorporateFareOutlined';
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';

import { SideNavButton } from '@/src/components/atoms/navButtons';

import { NavDivider } from './NavDivider';

export const CraftAdminNavLinks: FC = () => (
  <>
    <NavDivider />
    <SideNavButton icon={CorporateFareOutlined} page='system-organizations'>
      Organizations
    </SideNavButton>
    <SideNavButton icon={PeopleOutlined} page='manage-users'>
      People
    </SideNavButton>
    <SideNavButton icon={AdminPanelSettingsOutlined} page='craft-admin'>
      Craft Admin Tools
    </SideNavButton>
    <NavDivider />
  </>
);
